module.exports = __webpack_public_path__ + "img/selected2-min.a179939f.png";